import Image from 'next/image'
import justdentitLogo from './justdentit.png'

type IconProps = {
  className?: string
}

const JustdentitLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={justdentitLogo} alt="Justdentit Logo" height={48} {...attributes} />
}

export default JustdentitLogo
